module.exports = __webpack_public_path__ + "static/media/logoWithBlackText.faab3bb0.svg";